const isLocal = process.env.REACT_APP_NODE_ENV === "local";

// Production API URL - fallback if REACT_APP_API_URL not set
const PRODUCTION_API_URL = "https://athletics-club-platform.netlify.app/api";

const BASE_URL = isLocal
  ? "http://localhost:5000/api/v1"
  : process.env.REACT_APP_API_URL || PRODUCTION_API_URL;

const config = {
  BASE_URL,
};

export default config;
